import moment from "moment";

export const formatFullDate = (value) => {
  if (!value) return new Date();

  return new Date(moment(value, "DD/MM/YYYY").format());
};
